import { Skeleton } from "@/components/ui/skeleton";

const HeaderSkeleton = () => (
  <div className="space-y-2">
    <div className="flex items-center gap-2">
      <Skeleton className="h-5 w-16 rounded-full" />
      <Skeleton className="h-5 w-24 rounded-full" />
    </div>
    <Skeleton className="h-6 w-72" />
    <Skeleton className="h-3.5 w-48" />
  </div>
);

const FilterBarSkeleton = () => (
  <div className="flex items-center gap-3 bg-muted/50 rounded-lg p-3">
    <Skeleton className="h-9 w-[240px]" />
    <Skeleton className="h-9 w-[120px]" />
    <Skeleton className="h-9 flex-1" />
  </div>
);

const EntryRowSkeleton = () => (
  <div className="flex items-center gap-3 px-4 py-2.5">
    <Skeleton className="h-4 w-32" />
    <Skeleton className="h-4 w-24" />
    <Skeleton className="h-4 w-20" />
    <Skeleton className="h-4 w-16 ml-auto" />
  </div>
);

const YearGroupSkeleton = () => (
  <div className="border border-border rounded-lg overflow-hidden">
    <div className="flex items-center justify-between px-4 py-2.5">
      <div className="flex items-center gap-1.5">
        <Skeleton className="h-3.5 w-3.5" />
        <Skeleton className="h-4 w-12" />
      </div>
      <Skeleton className="h-4 w-20" />
    </div>
    <div className="divide-y divide-border">
      <EntryRowSkeleton />
      <EntryRowSkeleton />
      <EntryRowSkeleton />
    </div>
  </div>
);

const OrgGroupSkeleton = () => (
  <div className="space-y-3">
    <div className="flex items-center gap-2.5 py-2">
      <Skeleton className="h-3.5 w-3.5" />
      <Skeleton className="h-4 w-4 rounded" />
      <div className="space-y-1">
        <Skeleton className="h-4 w-40" />
        <Skeleton className="h-3 w-56" />
      </div>
    </div>
    <div className="ml-8 space-y-3">
      <YearGroupSkeleton />
    </div>
  </div>
);

const EntryViewSkeleton = () => (
  <div className="flex-1 min-h-0 overflow-y-auto space-y-4 py-4">
    <HeaderSkeleton />
    <FilterBarSkeleton />
    <div className="space-y-4">
      <OrgGroupSkeleton />
      <OrgGroupSkeleton />
    </div>
  </div>
);

export default EntryViewSkeleton;
